import dealerUsers from "@/router/layouts/mainLayout/settings/dealer-users";
import accessGroups from "@/router/layouts/mainLayout/settings/access-groups";
import users from "@/router/layouts/mainLayout/settings/users";
import dealerCompany from "@/router/layouts/mainLayout/settings/dealer-company";
import baseKnowledge from "@/router/layouts/mainLayout/settings/base-knowledge";
import news from "@/router/layouts/mainLayout/settings/news";
import roles from "@/router/layouts/mainLayout/settings/roles";
import bonuses from "@/router/layouts/mainLayout/settings/bonuses";
import newNotices from "@/router/layouts/mainLayout/settings/new-notices";
import customers from "@/router/layouts/mainLayout/settings/customers";
import dealershipApplications from "@/router/layouts/mainLayout/settings/dealership-applications";
import managers from "@/router/layouts/mainLayout/settings/managers";
import focusGroup from "@/router/layouts/mainLayout/settings/focus-group";
import categories from "@/router/layouts/mainLayout/settings/categories";
import promotions from "@/router/layouts/mainLayout/settings/promotions";

const settings = [
  ...dealerUsers,
  ...accessGroups,
  ...users,
  ...dealerCompany,
  ...baseKnowledge,
  ...roles,
  ...bonuses,
  ...news,
  ...newNotices,
  ...customers,
  ...dealershipApplications,
  ...managers,
  ...focusGroup,
  ...categories,
  ...promotions,
];

export default settings;
